/*eslint-disable*/
import React from "react";
import { useParams} from "react-router-dom";

// hooks
import useUser from "../../hooks/useUser";

// components
import PageHeader from "./components/pageHeader";
import UserInfo from "./components/userInfo";
import LoadingSpinner from "../../components/loadingSpinner";
import Error404 from "../../components/error404/Error404";

function ViewUser() {
  const { userId  } = useParams()
  const { user, isUserLoading } = useUser(userId);
  if (isUserLoading) {
    return (
      <div style={{
        width: '101vw',
        display: 'flex',
        justifyContent: 'center',
        height: '75vh',
        alignItems: 'center',
      }}
      >
        <LoadingSpinner />
      </div>
    )
  }
  if (Object.keys(user).length === 0){
    return (
      <Error404 />
    )
  }
  return (
    <>
      <PageHeader user={user} />
      <UserInfo user={user} />
    </>
  );
}

export default ViewUser;
